import gsap from "gsap";
import {
  AdditiveBlending,
  BoxGeometry,
  BufferGeometry,
  Color,
  Float32BufferAttribute,
  Group,
  InstancedMesh,
  LinearFilter,
  Mesh,
  MeshBasicMaterial,
  Object3d,
  PlaneGeometry,
  Points,
  PointsMaterial,
  TextureLoader,
  Vector2,
  Vector3
} from 'three';

const ranRange = function(min,
                          max) { return (Math.random() * (max - min)) + min; };

export default class SnowAnimation {

  constructor() {
    this.animating = false;
    this.inited = false;
    this.puddles = [];
    this.groundY = -.9;
    // this.setGround();
    this.loader = new TextureLoader();

    this.modeParams = {
      "rain" : {
        "sprite" : "/haiku-visualization/assets/images/sprite-rain.png",
        "opacity" : .7,
        "size" : .105
      },
      "snow" : {
        "sprite" :
            "/haiku-visualization/assets/images/sprite-snowflake3-01.png",
        "opacity" : .8,
        "size" : .15

      },
      "iris" : {
        "sprite" : "/haiku-visualization/assets/images/sprite-iris-02.png",
        "opacity" : 1,
        "size" : .1
      }
    }
  }

  init(scene, mode = "snow") {
    console.log("init mode", mode);
    if (this.inited) {

      if (this.mode != mode) {
        console.log("init new mode", this.mode, mode);
        this.initNewMode(mode);
      } else {
        console.log("inited turn on");
        gsap.to(this.material, {opacity : 1, duration : 2});
      }
      return;
    }

    this.mode = mode;

    this.positions = [];
    this.velocities = [];
    this.geometry = new BufferGeometry();
    this.numFlakes = 1000;
    this.scene = scene;
    this.hidden = false;

    for (let i = 0; i < this.numFlakes; i++) {
      if (mode == "snow") {

        this.positions.push(ranRange(-6, 6) - 2, ranRange(-.9, 10),
                            ranRange(0, 2) - 4);

        this.velocities.push((Math.random() - .5) * .005, Math.random() * .01,
                             (Math.random() - .5) * .005);
      } else if (mode == "rain") {
        this.positions.push(ranRange(0, 6) - 3, ranRange(2, 10),
                            ranRange(0, 4) - 3);

        this.velocities.push(0, 0.02, 0);
      } else if (mode == "iris") {
        this.positions.push(ranRange(0, 6) - 3, ranRange(0, 2),
                            ranRange(0, 4) - 3);

        this.velocities.push(ranRange(0, .005) - .0025,
                             ranRange(0, .005) - .0025,
                             ranRange(0, .005) - .0025);
      }
    }

    this.geometry.setAttribute('velocity',
                               new Float32BufferAttribute(this.velocities, 3));
    this.geometry.setAttribute('position',
                               new Float32BufferAttribute(this.positions, 3));

    this.material = new PointsMaterial({
      'size' : this.modeParams[this.mode].size,
      'map' : this.loader.load(this.modeParams[this.mode].sprite),
      'depthTest' : false,
      'transparent' : true,
      'opacity' : this.modeParams[this.mode].opacity
    });

    if (this.mode == "rain") {
      this.makePuddleMeshes();
    }
    this.particles = new Points(this.geometry, this.material);
    scene.add(this.particles);
    this.inited = true;
  }

  setGround(ground) { this.groundY = ground; }

  makePuddleMeshes(scene = null) {

    if (this.puddles.length > 0)
      return;

    if (scene != null)
      this.scene = scene;

    for (let i = 0; i < 100; i++) {
      const geometry = new PlaneGeometry(.2, .2);
      const material = new MeshBasicMaterial({
        'map' : this.loader.load(
            "/haiku-visualization/assets/images/sprite-puddle2.png"),
        'depthTest' : false,
        'depthWrite' : false,
        'transparent' : true,
        'opacity' : 0
      });
      const mesh = new Mesh(geometry, material);
      mesh.rotation.set(-Math.PI / 2, 0, 0);
      mesh.scale.set(0, 0, 0);
      mesh.state = "active";
      gsap.to(mesh.material, {
        opacity : 0,
        duration : Math.random() * 10,
        onComplete : () => { mesh.state = "dead"; }
      });
      this.puddles.push(mesh);
      this.scene.add(mesh);
    }

    // this.puddleMesh = new InstancedMesh(geometry,material,this.numFlakes);
    // this.scene.add(this.puddleMesh);
  }

  initNewMode(mode) {
    this.hidden = false;
    this.animating = false;
    this.mode = mode;
    this.material.map = this.loader.load(this.modeParams[this.mode].sprite);
    this.material.opacity = this.modeParams[this.mode].opacity;
    this.material.needsUpdate = true;
    this.material.size = this.modeParams[this.mode].size;

    for (let i = 0; i < this.numFlakes * 3; i += 3) {
      if (mode == "snow") {

        this.particles.geometry.attributes.position.array[i] =
            ranRange(-4, 4) - 2;
        this.particles.geometry.attributes.position.array[i + 1] =
            ranRange(-.9, 10);
        this.particles.geometry.attributes.position.array[i + 2] =
            ranRange(0, 2) - 4;

        this.particles.geometry.attributes.velocity.array[i] =
            (Math.random() - .5) * .005;
        this.particles.geometry.attributes.velocity.array[i + 1] =
            Math.random() * .01;
        this.particles.geometry.attributes.velocity.array[i + 2] =
            (Math.random() - .5) * .005;
      } else if (mode == "rain") {

        this.particles.geometry.attributes.position.array[i] =
            ranRange(0, 4) - 2;
        this.particles.geometry.attributes.position.array[i + 1] =
            ranRange(2, 5);
        this.particles.geometry.attributes.position.array[i + 2] =
            ranRange(0, 4) - 1;

        this.particles.geometry.attributes.velocity.array[i] = 0;
        this.particles.geometry.attributes.velocity.array[i + 1] = .02;
        this.particles.geometry.attributes.velocity.array[i + 2] = 0;
      } else if (mode == "iris") {
        this.particles.geometry.attributes.position.array[i] =
            ranRange(0, 4) - 2;
        this.particles.geometry.attributes.position.array[i + 1] =
            ranRange(0, 1);
        this.particles.geometry.attributes.position.array[i + 2] =
            ranRange(0, 4) - 1;

        this.particles.geometry.attributes.velocity.array[i] =
            ranRange(0, .005) - .0025;
        this.particles.geometry.attributes.velocity.array[i + 1] =
            ranRange(0, .005) - .0025;
        this.particles.geometry.attributes.velocity.array[i + 2] =
            ranRange(0, .005) - .0025;
      }

      this.particles.geometry.attributes.position.needsUpdate = true;
      this.particles.geometry.attributes.velocity.needsUpdate = true;
    }

    if (this.mode == "rain" && this.puddles.length == 0) {
      this.makePuddleMeshes();
    }

    gsap.to(this.material, {opacity : 1, duration : 2});
  }

  animate(dt) {
    if (!this.animating)
      return;
    for (let i = 0; i < this.numFlakes * 3; i += 3) {
      this.particles.geometry.attributes.position.array[i] -=
          this.particles.geometry.attributes.velocity.array[i];
      this.particles.geometry.attributes.position.array[i + 1] -=
          this.particles.geometry.attributes.velocity.array[i + 1];
      this.particles.geometry.attributes.position.array[i + 2] -=
          this.particles.geometry.attributes.velocity.array[i + 2];

      if (this.particles.geometry.attributes.position.array[i + 1] <
          this.groundY) {
        if (this.mode == "rain" && !this.hidden) {
          this.makePuddle(
              this.particles.geometry.attributes.position.array[i],
              this.groundY,
              this.particles.geometry.attributes.position.array[i + 2])
        }

        if (this.mode == "rain" || this.mode == "snow")
          this.particles.geometry.attributes.position.array[i + 1] =
              ranRange(2, 10);
      }
    }
    this.particles.geometry.attributes.position.needsUpdate = true;
  }

  makePuddle(x, y, z) {
    let index = null;
    for (let i = 0; i < this.puddles.length / 2; i++) {
      if (this.puddles[i].state == "dead") {
        index = i;
        break;
      }
    }
    if (index == null)
      return;

    let mesh = this.puddles[index];
    mesh.state = "active";
    mesh.position.set(x, y, z);

    let innerMesh = this.puddles[index + 50];
    innerMesh.state = "active";
    innerMesh.position.set(x, y, z);

    let scale = Math.random() + .25;
    gsap.to(mesh.scale, {x : scale, y : scale, z : scale, duration : 2});
    gsap.to(mesh.material, {opacity : .5, duration : .5});
    gsap.to(mesh.material, {
      opacity : 0,
      duration : 1,
      delay : 1,
      onComplete : function() {
        mesh.state = "dead";
        mesh.scale.set(0, 0, 0);
      }.bind(this)
    });

    gsap.to(innerMesh.scale,
            {x : scale * .5, y : scale * .5, z : scale * .5, duration : 1.5});
    gsap.to(innerMesh.material, {opacity : .5, duration : .5});
    gsap.to(innerMesh.material, {
      opacity : 0,
      duration : 1,
      delay : 1,
      onComplete : function() {
        innerMesh.state = "dead";
        innerMesh.scale.set(0, 0, 0);
      }.bind(this)
    });
  }

  clearParticlesSmooth() {
    if (!this.particles)
      return;
    gsap.to(this.material, {
      opacity : 0,
      duration : 2,
      onComplete : function() { this.animating = false; }.bind(this)
    });
  }

  addWind(dir) {
    this.windFactor = .001 * dir;
    let maxVel = .1;
    let minVel = -.1;
    for (let i = 0; i < this.numFlakes * 3; i += 3) {
      this.particles.geometry.attributes.velocity.array[i] =
          Math.max(minVel, Math.min(this.windFactor, maxVel));
    }
  }

  hide() {
    this.hidden = true;
    gsap.to(this.material, {opacity : 0, duration : 1});
  }

  show() {
    this.hidden = false;
    gsap.to(this.material, {opacity : 1, duration : 1});
  }

  toggleShow() {
    this.hidden = !this.hidden;
    if (!this.hidden)
      this.show();
    else {
      this.hide();
    }
  }
}
